import { Button, ButtonGroup } from "@bokio/designsystem/components/Button";
import { Modal, ModalContent } from "@bokio/designsystem/components/Modal";
import { SG } from "@bokio/designsystem/components/SpacingGroup/SpacingGroup";
import { Paragraph, Section } from "@bokio/designsystem/components/TypographicElements/TypographicElements";
import { SettingsLangFactory } from "@bokio/lang";
import { useCompanyInfo } from "@bokio/mobile-web-shared/core/contexts/CompanyInfoContext/CompanyInfoContext";
import { getRoute } from "@bokio/shared/route";
import htmlDecode from "@bokio/shared/utils/htmlDecode";

import type { FC } from "react";

interface CleanUpUsersModalProps {
	resolve: () => void;
}

export const CleanUpUsersModal: FC<CleanUpUsersModalProps> = ({ resolve }) => {
	const { companyInfo } = useCompanyInfo();
	const settingsLang = SettingsLangFactory();

	const paragraph1 = htmlDecode(settingsLang.CleanUpUsersModal_Content_1);

	const paragraph2 = htmlDecode(settingsLang.CleanUpUsersModal_Content_2);

	return (
		<Modal visible={true} title={settingsLang.CleanUpUsersModal_Title} onClose={resolve} disableBackgroundClick>
			<ModalContent>
				<Section>
					<SG gap="16">
						<Paragraph>{paragraph1}</Paragraph>
						<Paragraph>{paragraph2}</Paragraph>
						<ButtonGroup align="end">
							<Button appearance="secondary" type="button" onClick={resolve}>
								{settingsLang.CleanUpUsersModal_IUnderstand_action}
							</Button>
							<Button
								appearance="primary"
								type="link"
								route={getRoute("users", { company: companyInfo.Id }, {})}
								onNavigation={resolve}
							>
								{settingsLang.ManageUsers_action}
							</Button>
						</ButtonGroup>
					</SG>
				</Section>
			</ModalContent>
		</Modal>
	);
};
